export const FILTER_CONFIG = {
    FILTER_MIN: 100, // min limit of filter
    FILTER_MAX: 5000, // max limit of filter
    DEFAULT_MIN_MAX: [300, 1000], // default selected range
    STEP_COUNT: 200 // count added on each slide action
};
